var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// THIS IS A MOCK COMPONENT AND WILL BE REPLACED
import React, { PureComponent } from "react";
import { Select } from "@irati/ui/src/FormItem";
var MockPerkFilter = /** @class */ (function (_super) {
    __extends(MockPerkFilter, _super);
    function MockPerkFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            allPerks: [
                { label: "Cafe Nero", value: "dummy-uuid-1" },
                { label: "Apple", value: "dummy-uuid-2" },
                { label: "Asda", value: "dummy-uuid-3" },
                { label: "Costaa", value: "dummy-uuid-4" },
                { label: "PC World", value: "dummy-uuid-5" },
                { label: "Currys", value: "dummy-uuid-6" }
            ]
        };
        _this.handleChange = function (selectedPerks) {
            var onChange = _this.props.onChange;
            var perkUUIDList = selectedPerks.map(function (_a) {
                var value = _a.value;
                return value;
            });
            onChange(perkUUIDList);
        };
        return _this;
    }
    MockPerkFilter.prototype.render = function () {
        var value = this.props.value;
        var allPerks = this.state.allPerks;
        var selectedValues = value.split(",");
        return (React.createElement(Select, { isMulti: true, name: "ReportingPerkMockFilter", label: "Perks", onChange: this.handleChange, value: allPerks.filter(function (_a) {
                var optionValue = _a.value;
                return selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(optionValue);
            }), options: allPerks }));
    };
    return MockPerkFilter;
}(PureComponent));
export default MockPerkFilter;
